// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"a585ba7f","155":"71e24a2b","425":"3ad921a9","545":"a432c4fa"}[chunkId] + ".chunk.js";
};